import { useCallback as e, useEffect as t, useRef as n, useState as r } from "react";
//#region src/web/useVoiceRecorder.ts
var i = 300;
function a() {
	if (!(typeof MediaRecorder > "u" || !MediaRecorder.isTypeSupported)) return [
		"audio/webm;codecs=opus",
		"audio/webm",
		"audio/mp4",
		"audio/ogg"
	].find((e) => MediaRecorder.isTypeSupported(e));
}
function o(e) {
	return e.includes("webm") ? "webm" : e.includes("mp4") ? "m4a" : e.includes("ogg") ? "ogg" : e.includes("mpeg") ? "mp3" : "webm";
}
var s = (s) => {
	let c = s?.maxDurationSeconds ?? i, l = s?.onComplete, u = typeof navigator < "u" && !!navigator.mediaDevices?.getUserMedia && typeof MediaRecorder < "u", [d, f] = r(!1), [p, m] = r(0), [h, g] = r(null), _ = n(null), v = n(null), y = n([]), b = n(null), x = n(0), S = n(!1), C = n(l);
	C.current = l;
	let w = e(() => {
		v.current?.getTracks().forEach((e) => e.stop()), v.current = null, b.current &&= (clearInterval(b.current), null);
	}, []), T = e(async () => {
		if (!(!u || _.current)) {
			g(null);
			try {
				let e = await navigator.mediaDevices.getUserMedia({ audio: !0 });
				v.current = e, S.current = !1, y.current = [], x.current = 0, m(0);
				let t = a(), n = new MediaRecorder(e, t ? { mimeType: t } : void 0);
				_.current = n, n.ondataavailable = (e) => {
					e.data.size > 0 && y.current.push(e.data);
				}, n.onstop = () => {
					let e = n.mimeType || t || "audio/webm", r = new Blob(y.current, { type: e }), i = x.current, a = S.current;
					if (_.current = null, y.current = [], w(), f(!1), !a && r.size > 0) {
						let t = new File([r], `voice-note.${o(e)}`, { type: e });
						C.current?.({
							file: t,
							duration: i
						});
					}
				}, n.start(), f(!0), b.current = setInterval(() => {
					x.current += 1, m(x.current), x.current >= c && _.current?.stop();
				}, 1e3);
			} catch {
				w(), _.current = null, f(!1), g("Microphone access denied");
			}
		}
	}, [
		u,
		c,
		w
	]), E = e(() => {
		S.current = !1, _.current?.stop();
	}, []), D = e(() => {
		S.current = !0, _.current?.stop();
	}, []);
	return t(() => () => {
		S.current = !0, _.current?.stop(), w();
	}, [w]), {
		isSupported: u,
		isRecording: d,
		seconds: p,
		error: h,
		start: T,
		stop: E,
		cancel: D
	};
};
//#endregion
export { s as useVoiceRecorder };
